import React, { FC } from 'react';
import HpLazyImageWrapper from '../HpLazyImageWrapper/HpLazyImageWrapper';
import ResponsiveImage from '../ResponsiveImage';

import styles from './LargeItemCarouselItem.scss';

type Props = {
    item: {
        imageUrl: string | null;
        title: string | null;
        link: string | null;
    };
    isVisible?: boolean;
    onClick: () => void;
    useLazyLoadImages: boolean;
};

const LargeItemCarouselItem: FC<Props> = ({ item, isVisible, onClick, useLazyLoadImages }) => {
    const { imageUrl, title, link } = item;
    return (
        <a
            data-tn="hero-item-link"
            href={link || ''}
            className={styles.heroItem}
            style={{ opacity: isVisible ? '1' : '0' }}
            onClick={onClick}
        >
            <HpLazyImageWrapper useLazyLoad={useLazyLoadImages} className={styles.imageWrapper}>
                <ResponsiveImage
                    // no need for alt if title is present bc labeling the img with title is
                    // redundant with title as link text. only use alt if != title.
                    ariaHidden
                    className={styles.image}
                    src={imageUrl || ''}
                    dataTn="hero-item-image"
                    srcSetWidths={[200, 240]}
                />
            </HpLazyImageWrapper>
            <div
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: title || '' }}
                data-tn="hero-item-title"
            />
        </a>
    );
};

export default LargeItemCarouselItem;
